(() => {
  const ROOT_SELECTOR = '[data-gpused-product-description]';
  const CONTENT_SELECTOR = '[data-gpused-product-description-content]';
  const HEADING_SELECTOR = 'h2, h3';

  const hasMeaningfulContent = (element) =>
    Boolean(element.textContent.trim() || element.querySelector('img, video, table, ul, ol'));

  const enhance = (root) => {
    const content = root.querySelector(CONTENT_SELECTOR);
    if (!content || content.dataset.gpusedAccordionsReady === 'true') return;

    const sourceNodes = Array.from(content.childNodes);
    const headings = sourceNodes.filter(
      (node) => node.nodeType === Node.ELEMENT_NODE && node.matches(HEADING_SELECTOR),
    );
    const hasKeyDetailsHeading = headings.some((heading) =>
      /key product details/i.test(heading.textContent),
    );

    if (!headings.length) {
      content.dataset.gpusedAccordionsReady = 'true';
      return;
    }

    const fragment = document.createDocumentFragment();
    const introduction = document.createElement('div');
    introduction.className = 'gpused-product-description__intro';
    fragment.append(introduction);

    let currentBody = introduction;
    let openedSection = false;

    sourceNodes.forEach((node) => {
      if (node.nodeType === Node.ELEMENT_NODE && node.matches(HEADING_SELECTOR)) {
        const label = node.textContent.trim();
        const details = document.createElement('details');
        const summary = document.createElement('summary');
        const body = document.createElement('div');

        details.className = 'gpused-product-description__accordion';
        node.classList.add('gpused-product-description__accordion-heading');
        body.className = 'gpused-product-description__accordion-body';
        summary.append(node);
        details.append(summary, body);

        const isKeyDetails = /key product details/i.test(label);
        if (isKeyDetails || (!openedSection && !hasKeyDetailsHeading)) {
          details.open = true;
          openedSection = true;
        }

        fragment.append(details);
        currentBody = body;
        return;
      }

      currentBody.append(node);
    });

    if (!hasMeaningfulContent(introduction)) introduction.remove();
    content.replaceChildren(fragment);
    content.dataset.gpusedAccordionsReady = 'true';
  };

  const enhanceAll = (scope = document) => {
    scope.querySelectorAll(ROOT_SELECTOR).forEach(enhance);
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => enhanceAll(), { once: true });
  } else {
    enhanceAll();
  }

  document.addEventListener('shopify:section:load', (event) => enhanceAll(event.target));
})();
